import './auth/configureAmplify';
import 'aws-amplify/auth/enable-oauth-listener';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { CognitoAuthProvider } from '@caplend/cognito-auth';
import App from './App';
import createStore from './store/sagas';
import { registerStore } from './store/store';
import reportWebVitals from './reportWebVitals';
import cognito from './auth/cognito';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

const store = createStore();
registerStore(store);

root.render(
  //  <React.StrictMode>
  <CognitoAuthProvider cognito={cognito}>
    <Provider store={store}>
      <App />
    </Provider>
  </CognitoAuthProvider>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
